















import TableFilters from "../../core/Table/TableFilters.vue";
import TableSort from "../../core/Table/TableSort.vue";
import { TableColumn } from "../../models/UI/TableColumn";
import { ContactApi } from "../../api/ContactApi";
import { Option } from "../../models/Option";
import { Contact } from "../../models/Contact";

export default {
    name: "AvisDePrelevementListFilters",
    components: { TableSort, TableFilters },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            filters: {},
            ContactApi: new ContactApi(),
            columns: [
                {
                    id: "clientIds",
                    name: "Fournisseur",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "clients.nom",
                },
                {
                    id: "fournisseurName",
                    name: "Fournisseur (nom extrait)",
                    type: TableColumn.ColumnType.text,
                    sort_field: "fournisseur_name",
                },
                {
                    id: "reference",
                    name: "Référence",
                    type: TableColumn.ColumnType.text,
                    sort_field: "reference",
                },
                {
                    id: "date",
                    name: "Date de prélèvement",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "date",
                    // Pas de période par défaut : la liste affiche tous les
                    // avis et l'export PDF suit les filtres réellement posés.
                },
                {
                    id: "montant",
                    name: "Montant",
                    sort_field: "montant",
                },
                {
                    id: "created_at",
                    name: "Date d'ajout",
                    sort_field: "created_at",
                    default_sort: true,
                    default_value: TableColumn.SortOrder.desc,
                },
            ],
        };
    },
    created() {
        let self = this;
        self.ContactApi.getAllAsOptions({
            types: Contact.EType.Fournisseur,
            useCache: true,
        }).then(function (response) {
            let col = _.find(self.columns, { id: "clientIds" });
            col.options = Option.toTags(response);
        });
    },
    methods: {
        updateFilters(filters): void {
            this.filters = filters;
            this.$emit("update-filters", this.getFilters());
            this.$emit("input", this.getFilters());
        },
        updateSort(sort): void {
            this.$emit("update-sort", sort);
        },
        getFilters() {
            // Filtre fournisseur vide
            if (
                this.filters.clientIds &&
                _.includes(this.filters.clientIds, "-1")
            ) {
                this.filters.emptyClient = true;
            }
            return _.merge({}, this.filters);
        },
    },
};
